import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useToast } from '../../contexts/ToastContext'
import { Button, Input, Alert } from '../../components/ui'

export default function LoginPage() {
  const { login } = useAuth()
  const { success } = useToast()
  const navigate = useNavigate()
  const [form, setForm]     = useState({ email: '', password: '', remember: false })
  const [loading, setLoading] = useState(false)
  const [error, setError]   = useState('')

  const handle = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const data = await login(form.email, form.password, form.remember)
      if (data.two_factor_required) {
        navigate(`/2fa-challenge?token=${data.challenge_token}`)
        return
      }
      success('Welcome back!')
      const role = data.user?.role
      if (role === 'admin' || role === 'super_admin') navigate('/infra/admin')
      else if (role === 'client') navigate('/infra/client')
      else navigate('/engage')
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <h2 className="font-display font-bold text-xl text-white mb-1">Welcome back</h2>
      <p className="text-sm text-[var(--text-dim)] mb-7">Sign in to your Systeza account</p>

      {error && <Alert type="error" className="mb-5">{error}</Alert>}

      <form onSubmit={handle} className="space-y-5">
        <Input label="Email address" type="email" value={form.email}
          onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
          placeholder="you@company.com" required />
        <Input label="Password" type="password" value={form.password}
          onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
          placeholder="••••••••" required />
        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={form.remember}
              onChange={e => setForm(p => ({ ...p, remember: e.target.checked }))}
              className="w-4 h-4 rounded accent-[var(--color-primary)]" />
            <span className="text-xs text-[var(--text-dim)]">Remember me</span>
          </label>
          <Link to="/forgot-password" className="text-xs text-[var(--color-accent)] hover:underline">
            Forgot password?
          </Link>
        </div>
        <Button type="submit" loading={loading} className="w-full justify-center py-3">
          Sign in
        </Button>
      </form>

      <p className="text-center text-sm text-[var(--text-dim)] mt-6">
        Don't have an account?{' '}
        <Link to="/register" className="text-[var(--color-accent)] hover:underline font-medium">
          Create one
        </Link>
      </p>
    </>
  )
}
